import React from 'react';
import Seo from '../components/Seo';
import LandingHeader from '../components/LandingHeader';
import PricingSection from '../components/PricingSection';

export default function Pricing() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#F8FAFC] via-[#E0F2FE] to-[#D1FAE5] relative" data-testid="pricing-page">
      <Seo
        title="Pricing — Plus $4.99/mo, Pro $19.99/mo | MoneyFeed"
        description="MoneyFeed pricing: Free, Plus $4.99/mo and Pro $19.99/mo. Send receipts and expenses on WhatsApp — clean, categorized records for QuickBooks, Xero, or Excel."
        path="/pricing"
      />
      <LandingHeader />
      <div className="container mx-auto px-4 py-16 relative z-10">
        <div className="max-w-6xl mx-auto">
          <PricingSection />
        </div>
      </div>
    </div>
  );
}
